import styled from "@emotion/styled";
import Layout from "../../components/layout/Layout";
import { Header } from "../../components/typography/Header";
import {
  Paragraph,
  ParagraphHeaderXLarge,
} from "../../components/typography/Paragraph";
import {
  IconSize,
  SECTION_ACCESS_BLOCKER_BACKGROUND_COLOR_GRADIENT,
} from "../../components/theme";
import DocumentCart from "../../components/icons/DocumentCart";
import { PrimaryButton } from "../../components/buttons/PrimaryButton";
import { useNavigate } from "react-router";
import { StyledDescription } from "./Questionnaire";

const QuestionnairePaywallContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  background: ${SECTION_ACCESS_BLOCKER_BACKGROUND_COLOR_GRADIENT};
  border-radius: 16px;
  padding: 48px;
  margin-top: 24px;
`;

const QuestionnairePaywall = ({
  sectionName,
  sectionDescription,
}: {
  sectionName: string;
  sectionDescription: string;
}) => {
  const navigate = useNavigate();
  return (
    <Layout>
      <Header>{sectionName}</Header>
      <StyledDescription
        dangerouslySetInnerHTML={{ __html: sectionDescription }}
      />

      <QuestionnairePaywallContainer>
        <DocumentCart size={IconSize.XXXL} />
        <ParagraphHeaderXLarge>
          Ready to complete your prenup?
        </ParagraphHeaderXLarge>
        <Paragraph>
          To continue drafting your custom prenup, complete your payment.
        </Paragraph>
        <PrimaryButton onClick={() => navigate("/payment")}>
          Checkout
        </PrimaryButton>
      </QuestionnairePaywallContainer>
    </Layout>
  );
};

export default QuestionnairePaywall;
